import { useState, useEffect } from "react";
import {
  FaMapMarkerAlt,
  FaUser,
  FaBed,
  FaBath,
  FaRulerCombined,
} from "react-icons/fa";
import { MdAccessTime } from "react-icons/md";
import { getPropertyQRCode } from "../../../services/propertyService";

export default function PropertySummaryBox({ property }) {
  // 📌 State lưu QR code (dạng base64 hoặc URL)
  const [qrCode, setQrCode] = useState(null);

  // 📌 Gọi API lấy QR code khi car.id thay đổi
  useEffect(() => {
    if (property.id) {
      getPropertyQRCode(property.id)
        .then((data) => setQrCode(data.qrCode))
        .catch((err) => console.error("Lỗi tải QR code:", err));
    }
  }, [property.id]);

  // 📌 QR code Zalo cố định
  const zaloPhone = "0902487996";
  const zaloQR = `https://api.qrserver.com/v1/create-qr-code/?size=180x180&format=png&data=https://zalo.me/${zaloPhone}`;

  if (!property) {
    return (
      <div className="border p-4 rounded shadow-sm max-w-sm w-full bg-white text-center text-gray-500">
        Đang tải thông tin bất động sản...
      </div>
    );
  }

  const mapSrc =
    property?.latitude && property?.longitude
      ? `https://www.google.com/maps?q=${property.latitude},${property.longitude}&output=embed`
      : property?.location
        ? `https://www.google.com/maps?q=${encodeURIComponent(property.location)}&output=embed`
        : null;


  return (
    <div className="border p-4 rounded shadow-sm max-w-sm w-full bg-white">
      <h2 className="text-lg font-semibold text-blue-900 mb-1">
        {property?.projectName ?? "Chưa có tên dự án"}
      </h2>

      <p className="text-red-600 text-2xl font-bold mb-3">
        {property?.price
          ? `${property.price.toLocaleString("vi-VN")} ₫`
          : "Giá đang cập nhật"}
      </p>

      <ul className="text-sm text-blue-900 space-y-2 border-b pb-3 mb-3">
        <li className="flex justify-between">
          <span className="flex items-center font-medium gap-2"><FaBed /> Phòng ngủ</span>
          <span>{property?.bedrooms ?? "—"}</span>
        </li>

        <li className="flex justify-between">
          <span className="flex items-center font-medium gap-2"><FaBath /> Phòng tắm</span>
          <span>{property?.bathrooms ?? "—"}</span>
        </li>

        <li className="flex justify-between">
          <span className="flex items-center font-medium gap-2"><FaRulerCombined /> Diện tích</span>
          <span>{property?.area ? `${property.area} m²` : "—"}</span>
        </li>

        <li className="flex flex-col gap-1">
          <span className="flex items-center gap-2 text-sm font-medium text-blue-900">
            <FaMapMarkerAlt /> Địa điểm
          </span>
          <span className="text-sm text-gray-700">{property?.location || "—"}</span>
        </li>

        <li className="flex justify-between">
          <span className="flex items-center font-medium gap-2"><FaUser /> Môi giới</span>
          <span>{property?.user?.name || "Không rõ"}</span>
        </li>

        <li className="flex justify-between">
          <span className="flex items-center font-medium gap-2"><MdAccessTime /> Ngày đăng</span>
          <span>
            {property?.createdAt
              ? new Date(property.createdAt).toLocaleDateString("vi-VN")
              : "—"}
          </span>
        </li>
      </ul>

      {mapSrc && (
        <iframe
          src={mapSrc}
          width="100%"
          height="200"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Bản đồ vị trí bất động sản"
        ></iframe>
      )}

      {/* QR Zalo */}
      <div className="mb-3 text-center">
        <img
          src={zaloQR}
          alt="QR Code Zalo"
          className="mx-auto border p-2 rounded w-32 h-32 object-contain"
          onError={(e) => {
            e.target.src = `https://chart.googleapis.com/chart?chs=180x180&cht=qr&chl=https://zalo.me/${zaloPhone}`;
          }}
        />
        <p className="text-xs text-gray-500 mt-1">
          Quét để chat Zalo
        </p>
      </div>

      <div className="flex gap-2 mt-3">
        <a
          href={`tel:${property?.user?.phone || ""}`}
          className="bg-blue-600 text-white px-4 py-2 rounded w-1/2 text-sm font-medium text-center"
        >
          Gọi môi giới
        </a>
        <a
          href={`mailto:${property?.user?.email || ""}`}
          className="border border-blue-600 text-blue-600 px-4 py-2 rounded w-1/2 text-sm font-medium text-center"
        >
          Nhắn tin
        </a>
      </div>
    </div>
  );
}
